import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { CartContext } from '../context/CartContext';

const Cart = () => {
    const { cart, removeFromCart, updateQuantity, getSubtotal } = useContext(CartContext);

    if (cart.length === 0) {
        return (
            <div className="container cart-empty">
                <h1>Your Cart is Empty</h1>
                <p>Add some chess products to get started!</p>
                <Link to="/shop" className="btn btn-primary">
                    Browse Shop
                </Link>
            </div>
        );
    }

    return (
        <div className="container cart-page">
            <h1>Shopping Cart</h1>

            <div className="cart-content">
                <div className="cart-items">
                    {cart.map(item => (
                        <div key={item._id} className="cart-item">
                            <img src={item.imageUrl} alt={item.name} className="cart-item-image" />

                            <div className="cart-item-details">
                                <h3>{item.name}</h3>
                                <p className="cart-item-price">KSh {item.price.toFixed(2)}</p>
                            </div>

                            <div className="cart-item-quantity">
                                <button
                                    onClick={() => updateQuantity(item._id, item.quantity - 1)}
                                    className="qty-btn"
                                >
                                    -
                                </button>
                                <span className="qty-display">{item.quantity}</span>
                                <button
                                    onClick={() => updateQuantity(item._id, item.quantity + 1)}
                                    className="qty-btn"
                                    disabled={item.quantity >= item.stock}
                                >
                                    +
                                </button>
                            </div>

                            <div className="cart-item-total">
                                <p>KSh {(item.price * item.quantity).toFixed(2)}</p>
                            </div>

                            <button
                                onClick={() => removeFromCart(item._id)}
                                className="btn-remove"
                                aria-label="Remove item"
                            >
                                ×
                            </button>
                        </div>
                    ))}
                </div>

                <div className="cart-summary">
                    <h2>Order Summary</h2>

                    <div className="summary-row">
                        <span>Subtotal</span>
                        <span>KSh {getSubtotal().toFixed(2)}</span>
                    </div>

                    <div className="summary-row">
                        <span>Delivery</span>
                        <span>Calculated at checkout</span>
                    </div>

                    <div className="summary-row total">
                        <span>Total</span>
                        <span>KSh {getSubtotal().toFixed(2)}</span>
                    </div>

                    <Link to="/checkout" className="btn btn-checkout">
                        Proceed to Checkout
                    </Link>

                    <Link to="/shop" className="btn btn-continue">
                        Continue Shopping
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Cart;
